<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1049.6 1049.6"
    class="svg-icon icon"
  >
    <path
      id="circle"
      class="cls-1"
      d="M539.41,14.77c289.65,0,524.8,235.15,524.8,524.8s-235.15,524.8-524.8,524.8S14.61,829.21,14.61,539.57s235.16-524.8,524.8-524.8Zm0,56c258.75,0,468.83,210.07,468.83,468.83S798.16,1008.4,539.41,1008.4,70.58,798.32,70.58,539.57,280.66,70.74,539.41,70.74Z"
      transform="translate(-14.61 -14.77)"
    />
    <path
      id="icon"
      class="cls-1"
      d="M714.21,234.63H364.61A60.66,60.66,0,0,0,304,295.29V783.85a60.66,60.66,0,0,0,60.66,60.66H622.7a27.24,27.24,0,0,0,19.63-8.36l124.94-130a27.26,27.26,0,0,0,7.6-18.87v-392A60.66,60.66,0,0,0,714.21,234.63Zm-45,64.28A40.26,40.26,0,1,1,629,339.17,40.25,40.25,0,0,1,669.23,298.91Zm0,127.09A40.25,40.25,0,1,1,629,466.25,40.25,40.25,0,0,1,669.23,426Zm0,127.09A40.25,40.25,0,1,1,629,593.34,40.25,40.25,0,0,1,669.23,553.09ZM401.07,760.68a40.26,40.26,0,1,1,40.25-40.25A40.25,40.25,0,0,1,401.07,760.68Zm0-127.09a40.25,40.25,0,1,1,40.25-40.25A40.25,40.25,0,0,1,401.07,633.59Zm0-127.09a40.25,40.25,0,1,1,40.25-40.25A40.25,40.25,0,0,1,401.07,506.5Zm0-127.08a40.26,40.26,0,1,1,40.25-40.25A40.25,40.25,0,0,1,401.07,379.42ZM535.15,760.68a40.26,40.26,0,1,1,40.25-40.25A40.25,40.25,0,0,1,535.15,760.68Zm0-127.09a40.25,40.25,0,1,1,40.25-40.25A40.25,40.25,0,0,1,535.15,633.59Zm0-127.09a40.25,40.25,0,1,1,40.25-40.25A40.25,40.25,0,0,1,535.15,506.5Zm0-127.08a40.26,40.26,0,1,1,40.25-40.25A40.25,40.25,0,0,1,535.15,379.42ZM716.39,694.57l-93.28,93.55A7.29,7.29,0,0,1,610.67,783V705.9a23.76,23.76,0,0,1,23.75-23.75h76.81a7.28,7.28,0,0,1,5.16,12.42Z"
      transform="translate(-14.61 -14.77)"
    />
  </svg>
</template>

<script>
export default {
  name: "IconAllCandidates"
};
</script>

<style scoped>
.cls-1 {
  fill-rule: evenodd;
}
</style>
